import SmartLogger, { getLogger as getSmartLogger } from './smartLogger.js';

export const getLogger = getSmartLogger;
export default SmartLogger;
